<template>
	<BlogRoot
		v-if="!isLoading"
		:posts="list"
		:current-page="Number(pageNumber)"
		:previous-page="Number(previousPageNumber)"
		:category="category"
		:total-pages="total_pages"
	/>
	<div
		v-else
		class="h-[600px]"
	/>
	
</template>

<script setup>
import axios from "axios";

const { current_hostname } = useRuntimeConfig().public;
const hostname = useRuntimeConfig().public.hostname;
const $route = useRoute();
const $route_name = ref("");

const isLoading = ref(true);
const head_seo = computed(() => {
	if (yoast_head_json) {
		const filtered = Object.entries(yoast_head_json).filter(
			(item) =>
				![
					"title",
					"robots",
					"canonical",
					"schema_json",
					"WordPressAuthor_YoastHeadJson_Schema_"
				].includes(item[0])
		);
		return filtered;
	}

	return null;
});

const { data } = await useAsyncData("page_seo_data", async ({$router}) => {
	
	const params = $router.currentRoute._rawValue.params;

	const path = $router.currentRoute._rawValue.path;

	if(path === '/blog/'){
		return { redirected: true, url: '/blog/' }
	}

	const blogList = await useBlogListFetch();

	
	const { data } = await axios.get(`${hostname}wp-json/wp/v2/pages/9014/`);

	const { yoast_head_json, yoast_meta } = data;

	const { category_meta, total_pages, ...result } = await blogList;

	if (result.error) {
		return;
	}
	let parsed_schema;
	if (category_meta.schema_json) {
		parsed_schema = JSON.parse(category_meta.schema_json);

		const parsed_schema_id = parse_saswpSchema(
			parsed_schema["@graph"],
			hostname,
			current_hostname
		);

		parsed_schema["@graph"] = parsed_schema_id;
	}
	return {
		yoast_head_json,
		yoast_meta,
		schema_json: parsed_schema,
		category_meta,
		total_pages: Number(total_pages),
		...result
	};
});

if (!data.value) {
	throw createError({
		statusCode: 404,
		statusMessage: "Page Not Found",
		fatal: true
	});
}

const {
	yoast_head_json,
	list,
	pageNumber,
	previousPageNumber,
	category,
	schema_json,
	total_pages
} = data.value;

onMounted(async () => {

	if(data.value.redirected && process.client){
		return
	}
	else if (!data.value || !category) {
		throw createError({
			statusCode: 404,
			statusMessage: "Page Not Found",
			fatal: true
		});
	}

	$route_name.value = $route.name;

	if (list) {
		isLoading.value = false;
	}
	if (list && process.client) {
		await setTimeout(() => window.scrollTo(0, 1), 1000);
	}
});

useHead(() => {
	const metaTags = [];
	if (head_seo.value) {
		head_seo.value.forEach((tag) => {
			if (tag[0].startsWith('og_')) {
				metaTags.push({ property: 'og:' + tag[0].slice(3), content: tag[1][0]?.url || tag[1] });
			} else if (tag[0].startsWith('article')) {
				metaTags.push({ property: 'article:' + tag[0].slice(8), content: tag[1] });
			} else if (tag[0] !== 'twitter_misc' && tag[0].startsWith('twitter')) {
				metaTags.push({ name: 'twitter:' + tag[0].slice(8), content: tag[1] });
			} else if (tag[0] === 'twitter_misc') {
				metaTags.push({ name: 'twitter:label1', content: Object.keys(tag[1])[0] });
				metaTags.push({ name: 'twitter:data2', content: Object.values(tag[1])[0] });
				metaTags.push({ name: 'twitter:label2', content: Object.keys(tag[1])[1] });
				metaTags.push({ name: 'twitter:data1', content: Object.values(tag[1])[1] });
			} else if (tag[0] !== 'og_image') {
				metaTags.push({ name: tag[0], content: tag[1] });
			} else {
				metaTags.push({ property: tag[0].split('_').join(':') + ':type', content: tag[1][0].type });
				metaTags.push({ property: tag[0].split('_').join(':') , content: tag[1][0].url });
				metaTags.push({ property: tag[0].split('_').join(':') + ':width', content: tag[1][0].width });
				metaTags.push({ property: tag[0].split('_').join(':') + ':height', content: tag[1][0].height });
			}
		});
	}

	return {
		title: `${category?.name || ''} - Timothy Sykes`,
		link: [
			{
				rel: 'canonical',
				href: current_hostname +
					'category/' +
					($route.params.page
						? $route.params.categoryslug.join('/') + '/'
						: $route.params.categoryslug.join('/'))
			}
		],
		meta: metaTags,
		script: [
			{
				type: 'application/ld+json',
				class: 'saswp-schema-markup-output',
				innerHTML: JSON.stringify(schema_json)
			}
		]
	};
});
</script>
